import React from 'react';
import { Avatar } from '@components/basics/Images/Avatar';
import { useAuth } from '@context/auth/base';
import { DataTestId } from '@utils/test';

const TABLET_AVATAR_SIZE = 40;

export const HeaderAvatar = () => {
  const { authUser } = useAuth();

  if (!authUser) return null;

  return (
    <div className="h-7 w-7 md:h-10 md:w-10" data-testid={DataTestId.USER_MENU_CONTAINER}>
      <Avatar
        size={TABLET_AVATAR_SIZE}
        src={authUser.avatar?.url}
        walletAddress={authUser.publicAddress}
        username={authUser.username}
        disableLink
        borderRadius={1000}
        webappUri={authUser.webappUri}
      />
    </div>
  );
};
